import { Info } from "lucide-react";
import AnimatedValue from "./AnimatedValue";

export default function StatCard({ title, value, subtitle, icon: Icon, color = "red", trend, tooltip, onClick, loading, prefix = "" }) {
  const colorMap = {
    red: "text-[#B71C1C] bg-red-50",
    green: "text-green-600 bg-green-50",
    amber: "text-amber-600 bg-amber-50",
    blue: "text-blue-600 bg-blue-50",
    slate: "text-slate-600 bg-slate-100",
    purple: "text-purple-600 bg-purple-50",
  };

  return (
    <div
      data-testid={`stat-card-${title?.toLowerCase().replace(/\s+/g, "-")}`}
      onClick={onClick}
      className={`bg-white rounded-xl border border-slate-200 shadow-sm p-5 transition-all duration-200 hover:shadow-md ${onClick ? "cursor-pointer hover:-translate-y-0.5" : ""}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${colorMap[color]}`}>
          {Icon && <Icon size={18} strokeWidth={1.5} />}
        </div>
        {tooltip && (
          <div className="relative group">
            <Info size={14} className="text-slate-500 hover:text-slate-500 cursor-help" />
            <div className="absolute right-0 top-5 w-60 bg-slate-800 text-white text-xs rounded-lg p-3 opacity-0 group-hover:opacity-100 pointer-events-none z-50 shadow-xl transition-opacity">
              {tooltip}
            </div>
          </div>
        )}
      </div>
      <div className="space-y-0.5">
        {loading ? (
          <div className="h-8 w-24 bg-slate-100 rounded animate-pulse" />
        ) : value !== null && value !== undefined ? (
          <div className="text-2xl font-bold text-slate-900 leading-tight">
            {prefix}<AnimatedValue value={typeof value === "number" ? value.toLocaleString("en-IN") : value} />
          </div>
        ) : (
          <div className="text-sm text-slate-600 italic">N/A</div>
        )}
        <div className="text-xs font-medium text-slate-500 uppercase tracking-wide">{title}</div>
        {subtitle && <div className="text-xs text-slate-600">{subtitle}</div>}
        {trend && (
          <div className={`text-xs font-medium mt-1 ${trend.startsWith("↑") ? "text-green-600" : trend.startsWith("↓") ? "text-red-500" : "text-slate-500"}`}>
            {trend}
          </div>
        )}
      </div>
    </div>
  );
}
